import { render, staticRenderFns } from "./agents.vue?vue&type=template&id=ccdbc252&scoped=true"
import script from "./agents.vue?vue&type=script&lang=js"
export * from "./agents.vue?vue&type=script&lang=js"
import style0 from "./agents.vue?vue&type=style&index=0&id=ccdbc252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdbc252",
  null
  
)

export default component.exports